
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-flexible-funeral-plan-cmb.component.scss';

export class FormItemFlexibleFuneralPlanCmb extends Base {

	flexibleFuneralPlanCmbForm: HTMLFormElement;
	flexibleFuneralPlanCmbSubmit: Element[];	
	formLoader: Element;
	formThankyou: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.flexibleFuneralPlanCmbForm = this.element.querySelector('form') as HTMLFormElement;
		this.flexibleFuneralPlanCmbSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
	}

	bindEvents() {

		this.flexibleFuneralPlanCmbSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.flexibleFuneralPlanCmbForm.querySelectorAll('input, select');
			
			this.validationService.validate(formFields);
			const valid = Array.from(this.flexibleFuneralPlanCmbForm.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.flexibleFuneralPlanCmbForm);
			}
		}));
	}

	resetForm() {

		if (this.flexibleFuneralPlanCmbForm) {

			this.flexibleFuneralPlanCmbForm.reset();
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');

			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}

	}

	actionForm(form: HTMLFormElement) {

		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');
		
		// fields
		const product: any = form.querySelector('input[name=product]');
		const firstname: any = form.querySelector('input[name=first-name]');
		const lastname: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SBIS_Handler_COZA.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		// as per service
		if (product) {
			postData += 'product=' + product.value;
		}
		if (firstname) {
			postData += '&first=' + firstname.value;
		}
		if (lastname) {
			postData += '&last=' + lastname.value;
		}		
		if (contact) {
			postData += '&cell=' + contact.value;
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			this.formLoader.classList.remove('active');
			if (!response.data || (response.data.toString().includes('invalid'))) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				this.formThankyou.classList.add('active');
				success.classList.remove('active');
				success.classList.add('hidden');
				error.classList.remove('hidden');
				error.classList.add('active');
				
			} else {
				if (response.code) {
					analyticsService.dtmFormComplete('complete', response.code);
				} else if (response.status) {
					analyticsService.dtmFormComplete('complete', response.status);
				} else {
					analyticsService.dtmFormComplete('complete', "200");
				}
				this.formThankyou.classList.add('active');
				error.classList.remove('active');
				error.classList.add('hidden');
				success.classList.remove('hidden');
				success.classList.add('active');
				
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			this.formLoader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-flexible-funeral-plan-cmb/form-item-flexible-funeral-plan-cmb.component.ts